import React, { ComponentType } from 'react';
import { Field } from 'formik';

const FieldWrapper =
  <T,>(Component: ComponentType<T>) =>
  (props: Omit<T, 'form' | 'field'>) =>
    <Field component={Component} {...props} />;

export default FieldWrapper;
